// extracted by mini-css-extract-plugin
module.exports = {"AddressContainer":"AddressSaved_AddressContainer__16CaQ","Title":"AddressSaved_Title__I14oI","Address":"AddressSaved_Address__2ZipH"};